import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import OverrideIndicator from 'lumen/components/hotel/pricing-assistant/override-indicator';
import type { Period } from 'lumen/models';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';

import styles from './pricing-assistant-table-tooltip.module.css';

interface HotelPricingAssistantTableTooltipsTooltipStayRestrictionsTableSignature {
  Args: {
    period: Period;
  };
}

export default class HotelPricingAssistantTableTooltipsTooltipStayRestrictionsTable extends Component<HotelPricingAssistantTableTooltipsTooltipStayRestrictionsTableSignature> {
  @service declare featureToggle: Services['feature-toggle'];

  get hasMinLosOverride(): boolean {
    return this.args.period.hasMinLosOverride;
  }

  get isLoading(): boolean {
    if (
      !this.featureToggle.hasFeatureToggle(
        FEATURE_TOGGLES.DAY_OVERRIDE_MODAL_RESTRICTIONS_TAB,
      )
    ) {
      return false;
    }

    return this.args.period.hasMinLosActionInProgress;
  }

  get minLos(): number | null {
    return this.args.period.effectiveMinLosWithOverride;
  }

  <template>
    <table
      class="default-table {{styles.table}}"
      data-test-stay-restrictions-section
    >
      <thead>
        <tr>
          <th class="{{styles.table-header}} text-200--bold">
            {{t "pricing_assistant.stay_restrictions.header"}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="{{styles.table-row-cell}} text-200--regular">
            {{#if this.isLoading}}
              <div class="loading-pulse w-5/6" data-test-loading></div>
              <div class="loading-pulse w-1/6"></div>
            {{else}}
              <p class="text-200--regular">
                {{t "general.hotel"}}
              </p>
              <div class="flex items-center">
                <p
                  class="text-200--regular"
                  data-test-stay-restrictions-hotel-value
                >
                  {{#if this.minLos}}
                    {{t
                      "pricing_assistant.stay_restrictions.min_los"
                      count=this.minLos
                    }}
                  {{else}}
                    {{t "pricing_manager.restrictions.no_restrictions"}}
                  {{/if}}
                </p>
                {{#if this.hasMinLosOverride}}<OverrideIndicator />{{/if}}
              </div>
            {{/if}}
          </td>
        </tr>
      </tbody>
    </table>
  </template>
}
